import { EMPTY_STRING } from '../../../NonReact/constants/Common'
import { AgentDTO } from '../../../NonReact/Types/Types'
import { ALL_VALUE } from '../../Common/API/ItemsGetters'
import { AgentForm } from '../Types/Types'

const trimStrings = (str?: string): Definable<string> => str?.Trim()

export const serverToFormState = ({
    AgentGUID,
    AgentNumber,
    AgentNumberInternal,
    ChatIntegrationType,
    ConcurrentChannelsHandlingAllowed,
    Description,
    EmailIntegrationType,
    IDOnTelSys,
    IDOnTelSysDivision,
    IDOnTelSysOwner,
    OverrideMonitoring,
    PartIDInTelSys,
    TelSysUserID,
    TelSysComponentType,
    EmailSysEmailAddress,
    IDOnChatSys,
    IDOnEmailSys
}: AgentDTO): AgentForm => ({
    details: {
        guid: AgentGUID ?? EMPTY_STRING,
        agentNumber: AgentNumber ?? EMPTY_STRING,
        partition: PartIDInTelSys ?? ALL_VALUE,
        description: Description ?? EMPTY_STRING
    },
    advanced: {
        callCentreLicenceType: TelSysComponentType ?? EMPTY_STRING,
        internalNumber: AgentNumberInternal ?? EMPTY_STRING,
        ciscoCommonID: TelSysUserID ?? EMPTY_STRING,
        overrideMonitoring: OverrideMonitoring ?? false,
        webexCallingUserID: IDOnTelSys ?? EMPTY_STRING,
        broadworksUserID: IDOnTelSys ?? EMPTY_STRING,
        oidOnTelServer: IDOnTelSys ?? EMPTY_STRING,
        owningDepartment: IDOnTelSysDivision ?? EMPTY_STRING,
        owningGroupID: IDOnTelSysOwner ?? EMPTY_STRING,
        teamsUserID: IDOnTelSys ?? EMPTY_STRING,
        userPrincipalName: TelSysUserID ?? EMPTY_STRING
    },
    omnichannel: {
        allowConcurrentChannels: ConcurrentChannelsHandlingAllowed ?? false,
        chat: {
            chatIntegrationType: ChatIntegrationType ?? EMPTY_STRING,
            chatIDOnChatSystem: IDOnChatSys ?? EMPTY_STRING
        },
        email: {
            emailIntegrationType: EmailIntegrationType ?? EMPTY_STRING,
            emailAddress: EmailSysEmailAddress ?? EMPTY_STRING,
            emailIDOnEmailSystem: IDOnEmailSys ?? EMPTY_STRING
        }
    }
})

export const formStateToServer = (
    telSysID: number,
    {
        details: { guid, agentNumber, partition, description, updateItems },
        advanced: {
            callCentreLicenceType,
            internalNumber,
            ciscoCommonID,
            overrideMonitoring,
            webexCallingUserID,
            broadworksUserID,
            oidOnTelServer,
            owningDepartment,
            owningGroupID,
            teamsUserID,
            userPrincipalName
        },
        omnichannel
    }: AgentForm,
    hasOriginalAgentNumberChanged: boolean,
    editMode: boolean
): AgentDTO => {
    const idOnTelSys: Definable<string> = trimStrings(
        teamsUserID ?? webexCallingUserID ?? broadworksUserID ?? oidOnTelServer
    )

    const agentDTO: AgentDTO = {
        AgentGUID: guid,
        AgentNumber: agentNumber,
        TelSysID: telSysID,
        PartIDInTelSys: partition,
        Description: trimStrings(description),
        UpdateExistingItems: updateItems,

        TelSysComponentType: trimStrings(callCentreLicenceType),
        AgentNumberInternal: trimStrings(internalNumber),
        TelSysUserID: trimStrings(userPrincipalName ?? ciscoCommonID),
        OverrideMonitoring: overrideMonitoring,
        IDOnTelSys: idOnTelSys,
        IDOnTelSysDivision: trimStrings(owningDepartment),
        IDOnTelSysOwner: trimStrings(owningGroupID),

        ConcurrentChannelsHandlingAllowed: omnichannel?.allowConcurrentChannels,
        ChatIntegrationType: trimStrings(omnichannel?.chat?.chatIntegrationType),
        IDOnChatSys: trimStrings(omnichannel?.chat?.chatIDOnChatSystem),
        EmailIntegrationType: trimStrings(omnichannel?.email?.emailIntegrationType),
        EmailSysEmailAddress: trimStrings(omnichannel?.email?.emailAddress),
        IDOnEmailSys: trimStrings(omnichannel?.email?.emailIDOnEmailSystem)
    }

    if (hasOriginalAgentNumberChanged) agentDTO.AgentNumberNew = agentNumber
    if (editMode) agentDTO.IDOnTelSysNew = idOnTelSys

    return agentDTO
}
